import { AsyncPipe, NgClass, NgIf, NgStyle } from "@angular/common";
import { ChangeDetectorRef, Component, inject, NgZone, OnInit, signal, ViewChild } from "@angular/core";
import { collection, collectionSnapshots, Firestore, QueryDocumentSnapshot } from "@angular/fire/firestore";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { MatDialog } from "@angular/material/dialog";
import { DomSanitizer, SafeStyle } from "@angular/platform-browser";
import { ActivatedRoute, Data, NavigationEnd, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { AuthGamesService } from "@core/AuthServices/authGames/auth-games.service";
import { AuthPartialRegService } from "@core/AuthServices/authPartialReg/auth-partial-reg.service";
import { CatchErrorService } from "@core/catch-error.service";
import { CelebrationAnimationService } from "@core/celebration-animation.service";
import { LoadingService } from "@core/loading.service";
import { UtilityService } from "@core/utility.service";
import { Slides } from "@interfaces/slides";
import { ITimer } from "@interfaces/timer";
import { IonContent, IonicModule, ModalController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { BehaviorSubject, firstValueFrom, Observable, of, Subject, Subscription, throwError, timer } from "rxjs";
import { catchError, concatMap, filter, map, shareReplay, switchMap, take, takeUntil, tap } from "rxjs/operators";
import { safeArrayAccess, safeArrayFilter, safeArraySlice, hasArrayMinLength } from "@core/safe-access.utility";
import { CommonVariable } from "src/app/app.constants";
import { CountDownTimerAppComponent } from "src/app/components/count-down-timer-app/count-down-timer-app.component";
import { InboxMessageComponent } from "src/app/components/inbox-message/inbox-message.component";
import { RegProfileDialogComponentComponent } from "src/app/components/reg-profile-dialog-component/reg-profile-dialog-component.component";
import { StoreTopUpComponent } from "src/app/components/store-top-up/store-top-up.component";
import { AnimationService } from "src/app/services/animation.service";
import { AppPaymentService } from "src/app/services/AppRootService/app-payment.service";
import { CommonService } from "src/app/services/common/common.service";
import { GameBalanceService } from "src/app/services/game-balance.service";
import { GTMSagmentService } from "src/app/services/gtm-sagment.service";
import { HomeDataService } from "src/app/services/home-data.service";
import { JackpotTriggersService } from "src/app/services/jackpot-triggers.service";
import { NarratorService } from "src/app/services/narrator.service";
import { NotificationManagerService } from "src/app/services/notification-manager.service";
import { NotificationsService } from "src/app/services/notifications.service";
import { OrientationService } from "src/app/services/orientation.service";
import { PaymentService } from "src/app/services/payment.service";
import { RequestBodyService } from "src/app/services/request-body.service";
import { SliderManagerService } from "src/app/services/slider-manager.service";
import { UserManagementService } from "src/app/services/user-management.service";
import { VoucherService } from "src/app/services/vouchers.service";
import Swiper from "swiper";
import type { SwiperOptions } from "swiper/types";
import { SwiperComponent, SwiperModule } from "swiper/angular";
import { CountDownTimerComponent } from "../../components/count-down-timer/count-down-timer.component";
import { InProgressAnimationComponent } from "../../components/in-progress-animation/in-progress-animation.component";
import { NewCountDownTimerComponent } from "../../components/new-count-down-timer/new-count-down-timer.component";
import { AddHomeScreenBannerComponent } from "../../components/add-home-screen-banner/add-home-screen-banner.component";
import { PushNotificationBannerComponent } from "../../components/push-notification-banner/push-notification-banner.component";
import { TopHeaderComponent } from "../../components/top-header/top-header.component";
import { formatDecimalNumbersInString } from "../../core/currency-display.util";
import { DisplayCurrencyPipe } from "../../pipe/display-currency.pipe";
import { FormatJackpot } from "../../pipe/formatJackpot";
import { SafeHtmlPipe } from "../../pipe/safehtmlpipe";
import { AccountRepositoryService } from "../account/account-repository.service";
import { GamesRepositoryService } from "../games/games-repository.service";
import { HomeRepositoryService } from "../home/home-repository.service";
import { SyndicateRepositoryService } from "../syndicate/syndicate-repository.service";
import { SyndicateTicketsComponent } from "../syndicate/syndicate-tickets/syndicate-tickets.component";
import { OfferOfDayDetailComponent } from "./offerOfDayDetail/offerOfDayDetail.component";
import { StoreJackpotBottomsheetComponent } from "./store-jackpot-bottomsheet/store-jackpot-bottomsheet.component";
import { StoreJackpotRepositoryService } from "./store-jackpot.service";
import { StorePaymentComponent } from "./store-payment/store-payment.component";
import { StoreRepositoryService } from "./store-repository.service";
import { StoreJackpotTriggerDataService } from "./services/store-jackpot-trigger-data.service";
import { StoreSwiperManagerService } from "./services/store-swiper-manager.service";
import { StoreNotificationService } from "./services/store-notification.service";
import { StoreJackpotTriggerFacadeService } from "./services/store-jackpot-trigger-facade.service";
import { GameCelebrationService } from "../games/services/game-celebration.service";
import { ClarityService } from "src/app/services/clarity.service";
import { VoucherNotificationService } from "src/app/components/vouchers/voucher-notification.service";

@Component({
  selector: "app-store",
  templateUrl: "./store.page.html",
  styleUrls: ["./store.page.scss"],
  standalone: true,
  imports: [
    TopHeaderComponent,
    IonicModule,
    SwiperModule,
    NgClass,
    NgStyle,
    CountDownTimerComponent,
    PushNotificationBannerComponent,
    AddHomeScreenBannerComponent,
    InProgressAnimationComponent,
    AsyncPipe,
    DisplayCurrencyPipe,
    SafeHtmlPipe,
    TranslatePipe,
    FormatJackpot,
    LottieComponent,
    NewCountDownTimerComponent,
    NgIf,
    CountDownTimerAppComponent],
})
export class StorePage implements OnInit {
  private firestore = inject(Firestore);
  private route = inject(Router);
  private bottomSheet = inject(MatBottomSheet);
  private storeService = inject(StoreRepositoryService);
  private storeJackpotService = inject(StoreJackpotRepositoryService);
  private authService = inject(AuthService);
  private modalController = inject(ModalController);
  private changeDetectorRef = inject(ChangeDetectorRef);
  private paymentService = inject(PaymentService);
  private homeRepositoryService = inject(HomeRepositoryService);
  private translate = inject(TranslateService);
  private jackpotTriggerService = inject(JackpotTriggersService);
  private orientationService = inject(OrientationService);
  private celebrationAnimationService = inject(CelebrationAnimationService);
  private catchService = inject(CatchErrorService);
  private sliderManagerService = inject(SliderManagerService);
  private loadingService = inject(LoadingService);
  private voucherService = inject(VoucherService);
  private matDialog = inject(MatDialog);
  private GTMSagmentService = inject(GTMSagmentService);
  private AuthGamesService = inject(AuthGamesService);
  private AuthPartialRegService = inject(AuthPartialRegService);
  private animationService = inject(AnimationService);
  private notificationManagerService = inject(NotificationManagerService);
  private userManagementService = inject(UserManagementService);
  private homeDataService = inject(HomeDataService);
  private gameBalanceService = inject(GameBalanceService);
  private narratorService = inject(NarratorService);
  private gamesRepositoryService = inject(GamesRepositoryService);
  private syndicateService = inject(SyndicateRepositoryService);
  private accountService = inject(AccountRepositoryService);
  private readonly sanitizer = inject(DomSanitizer)
  private actRoute = inject(ActivatedRoute);
  private requestBodyService = inject(RequestBodyService);
  private commonService = inject(CommonService);
  private ngZone = inject(NgZone);
  public countdownSeconds: number | null;
  public voucherNotificationService = inject(VoucherNotificationService);
  private notificationsService = inject(NotificationsService);
  private clarityService = inject(ClarityService);
  private jackpotTriggerDataService = inject(StoreJackpotTriggerDataService);
  private swiperManager = inject(StoreSwiperManagerService);
  private storeNotificationService = inject(StoreNotificationService);
  private jackpotTriggerFacade = inject(StoreJackpotTriggerFacadeService);

  storePageDataOne$ = new BehaviorSubject<Data | null>(null);
  storePageData: Data;
  triggerActivationStatus = signal<boolean>(false);
  private isComponentActive = true;
  country_name: string;
  selectedLanguage: string = CommonVariable.preferredLanguage;
  @ViewChild("pageTop") pageTop: IonContent;
  msn: number;
  countryCode: any;
  countryCodeSignal = signal<any>([]);
  topSection: string;
  bottomSection: string;
  sortedArrayField = [] as string[];
  private unsubscribe$ = new Subject<void>();
  showView;
  orderedInactiveJackpots: string;
  orderedActiveJackpots: string;
  speed: number;
  showDivSlider: boolean = false;
  isToolShow: boolean;
  timer: number;
  showToolTip$ = new BehaviorSubject(true);
  public isTooltipVisible: boolean;
  jackpotData = [];
  public dailyPromoSliderData: Data;
  isJptActived = signal<boolean>(false);
  dailyPromotionSlideData: Data;
  dailyPromotionSlideDataSignal = signal<Data>(null);
  protected visibilityControl = signal<string>("");
  protected operatorSelection = signal<string>("");
  protected isCreditRefresh = signal<boolean>(false);
  protected isBannerDisplay = signal<boolean>(false);
  protected jackpotTriggerActiveCount = signal<number>(0);
  bundlePromotionSlideData: Data;
  storeSliderSubscription: Subscription;
  public creditRefreshStatusSubscription: Subscription;
  public jackpotActivatedCountSubscription: Subscription;
  hasCustomStyle = false;
  hasBundleStyle = false;
  autoplayJackpot: boolean = true;
  public firstRetoolSlideContent: Data;
  public firstRetoolSlideContentSignal = signal<Data>(null);
  public autoSlide: boolean;
  public isNotExpiredCard: boolean;
  public feedBackTypeFormViewed: boolean;
  public typeformUrlId: string;
  public notificationData: Data;
  public showPointsNotification = false;
  public creditToolTip = 6;
  private destroy$ = new Subject<void>();
  private animationDestroy$ = new Subject<void>();
  private cleanup$ = new Subject<void>();
  updateAnimationSubject = new Subject<{ location_id: string; delayTime: number }>();
  response = new BehaviorSubject<Data>(null);
  creditCTAOptions: AnimationOptions = { path: "" };
  firstProductOptions: AnimationOptions = { path: "" };
  creditCTAStatus: boolean;
  jackpotTriggerAnimationOptions: AnimationOptions = {
    path: "../../../assets/lotti_animation/trigger_activation_animation/jacpot-trigger.json", // Path to your Lottie animation
    loop: false, // Enable looping
    autoplay: true,
  };
  firstProductStatus: boolean;
  creditCTADuration: number;
  firstProductDuration: number;
  isVoucherClaimedSignal = signal<boolean>(false);
  @ViewChild("slider") slider: SwiperComponent;
  @ViewChild("storePageCardSlider") storeCardSlider: SwiperComponent;
  storeSliderOptions: SwiperOptions = {
    speed: 400,
    slidesPerView: 1.1,
    centeredSlides: true,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination_",
      clickable: true,
    },
    // Disabled: slides contain CTA buttons that navigate away. Swiper's click handler queues
    // a requestAnimationFrame callback which races with ionViewWillLeave() tearing down the
    // component, leaving params undefined — "Cannot read properties of undefined (reading 'loop')".
    // Explicit false prevents regressions if Swiper defaults ever change. LOTTOSOCIAL-PWA-1NCK
    slideToClickedSlide: false,
  };
  slides: Swiper;
  swiperInstance: Swiper | null = null; // store swiper data
  interval;
  storeSliderOptions2: SwiperOptions = {
    speed: 500,
    slidesPerView: 1.15,
    centeredSlides: true,
    pagination: {
      el: ".swiper-pagination-2",
      clickable: true,
    },
    // Disabled: same CTA-navigation race as storeSliderOptions above. Explicit false prevents
    // regressions if Swiper defaults or shared configs change. LOTTOSOCIAL-PWA-1NCK
    slideToClickedSlide: false,
    autoplay: {
      delay: 5000,
    },
  };
  fragmentAlias: string;
  inlineNotificationDetails: Data = {};
  sliderAliasSub: Subscription;
  private sliderManagerSubscription: Subscription;
  xpsDetailSubscription: Subscription;
  private sqlAPICallResponse: string | number;
  // Declare a variable to hold the subscription
  private sampleSubscription: Subscription;
  private userInboxSubscription: Subscription;
  languageSubscription: Subscription;
  private sloganSubscription?: Subscription;
  slogans: Data;
  show$ = this.authService.getOnboardingStatus().pipe(
    map(([data, user]) => {
      const shouldShow = !!user && !data?.coachmark?.credit_topup;
      this.isTooltipVisible = shouldShow;
      if (shouldShow) {
        this.storeToolTip$ = this.homeRepositoryService?.toolTipText$;
      }
      return shouldShow;
    }),
    catchError((error) => {
      return of(false);
    })
  );


  sliderJackpot$ = this.jackpotTriggerDataService?.jackpotTrigger$?.pipe(
    map((res: Data) => {
      if (!res) return;
      return res?.userJackpots;
    })
  );

  storePageData$ = this.storeService?.storePageData$?.pipe(
    map((res) => {
      // Early return if res is not an array or is empty
      if (!Array.isArray(res) || !res.length) {
        return [];
      }

      const jackpotOrder$ = this.authService?.userDetails$?.subscribe((user: Data) => {
        this.countryCodeSignal.set(user?.country_code ?? "");
        this.countryCode = this.countryCodeSignal();
        // Ensure res[0]?.jackpot_order is an array
        this.sortedArrayField = this.getJackpotOrder(
          Array.isArray(res[0]?.jackpot_order) ? res[0]?.jackpot_order : [],
          this.countryCodeSignal()
        );
      });

      try {
        // Initialize as an array
        let lotteryProducts = UtilityService.jackpotSortingStorePage(res, this.sortedArrayField) || [];

        // Unsubscribe from jackpotOrder$ after use
        jackpotOrder$.unsubscribe();
        // Ensure filtering only on arrays with defensive checking
        const filteredLotteries = safeArrayFilter(lotteryProducts, (lottery : Data) => {
          // Assuming `valid_countries` is an array in each lottery product that lists valid country codes
          return !lottery?.valid_countries || (Array.isArray(lottery.valid_countries) && lottery.valid_countries.includes(this.countryCode));
        });

        this.userManagementService
          .getUserCountryBaseOnIP()
          ?.pipe(takeUntil(this.destroy$))
          ?.subscribe({
            next: (res) => {
              this.country_name = res?.country_name;
            },
            error: (err) => {
              return err;
            },
          });
        // Custom sorting logic when countryCode is '44' (UK)
        if (this.country_name === "United Kingdom") {
          filteredLotteries.sort((a, b) => {
            // Bring 'Lotto' and 'EuroMillions' to the top
            const topLotteries = ["Lotto", "EuroMillions"];

            const indexA = topLotteries?.indexOf(a?.real_name);
            const indexB = topLotteries?.indexOf(b?.real_name);

            // If 'a' or 'b' is one of the top lotteries, prioritize them
            if (indexA !== -1 || indexB !== -1) {
              return (indexA === -1 ? 1 : 0) - (indexB === -1 ? 1 : 0);
            }
            // Otherwise, keep the original order
            return 0;
          });
        }
        // Slice the lotteries for top and bottom sections with safe bounds checking
        const topLotteries = safeArraySlice(filteredLotteries, 0, 2);
        const bottomLotteries = safeArraySlice(filteredLotteries, 2);

        // Get featured and non-featured lotteries with defensive filtering
        const getFeatured = safeArrayFilter(bottomLotteries, (d) => d?.jackpot?.featured === true)
          .sort(
            (a, b) => this.getJackpotValue(b?.jackpot?.jackpot_value) - this.getJackpotValue(a?.jackpot?.jackpot_value)
          );

        const getNonFeatured = safeArrayFilter(bottomLotteries, (d) => d?.jackpot?.featured === false)
          .sort(
            (a, b) => this.getJackpotValue(b?.jackpot?.jackpot_value) - this.getJackpotValue(a?.jackpot?.jackpot_value)
          );

        // Final lotteries array, combining top lotteries, featured, and non-featured
        const finalLotteries = [...topLotteries, ...getFeatured, ...getNonFeatured];
        // Preload top lotteries for display with safe bounds
        if (hasArrayMinLength(topLotteries, 1)) {
          this.storeService.preloadTopLotteries(topLotteries);
        }

        return finalLotteries;
      } catch (e) {
        this.authService?.errorHandlerLogs("Error in storePageData$ map:", e);
        return [];
      }
    }),
    tap((data) => {
      this.showView = false;
      if (data && !this.showView) {
        this.userInboxSubscription?.unsubscribe();
        this.userInboxSubscription = this.homeDataService?.userInbox$
          .pipe(
            map((data: Data[]) => {
              if (!data || !data.length) {
                return [];
              }
              const filtered = data.filter((values: Data) =>
                values?.auto_show &&
                !values?.viewed &&
                ["store", "all"].includes(values?.auto_show_inbox_page)
              );
              return filtered;
            }),
            tap(() => {
              this.ngZone.run(() => this.changeDetectorRef.detectChanges());
            })
          )
          .subscribe(
            (data: Data[]) => {
              if (data?.length > 0) {
                if (data[0]?.inbox_template) {
                  this.AuthPartialRegService?.openTemplate(data[0]);
                } else {
                  this.notificationManagerService.addNotification({ ...data[0], type: "auto_show_inbox" });
                }
              } else {
                return;
              }
            }
          );
      }

    })
  );

  // Get Jackpot Trigger Order By expiry date
  jackpotsOrderSub = this.storeJackpotService?.sortedJackpots$
    ?.pipe(takeUntil(this.destroy$)) // Ensures auto-unsubscription
    ?.subscribe((res: Data[]) => {
      if (!Array.isArray(res) || !res.length) return; // Ensure `res` is a valid array
      this.jackpotData = res
        .filter((jackpot: Data) => jackpot && jackpot?.id) // Filter out invalid data
        .map((jackpot: Data) => jackpot?.id.toLowerCase()) // Convert IDs to lowercase
        .reverse(); // Reverse the array
    });

  jackpotTriggers$ = this.jackpotTriggerDataService?.jackpotTriggers$;
  flashSaleStyleString = "flash_sale";
  flashSaleWidth$ = this.authService?.selectedlanguageObservable$?.pipe(
    map((res) => {
      let width = "90px";
      switch (res) {
        case "en":
          width = "82px";
          break;
        case "it":
          width = "95px";
          break;
        case "es":
          width = "88px";
          break;
        case "fr":
          width = "86px";
          break;
        default:
          width = "88px";
      }
      return width;
    })
  );

  $timer: ITimer[];
  runTimer = true;
  accountBalance$ = this.authService?.userCurrentBalance$;
  jackpots;
  loadings = true;
  storeToolTip$: any;
  heading: string;
  jackpotName: string;
  showTool: boolean = false;
  storeTranslatedData: any;
  protect: any;
  triggerActiveCount: any;
  jackpotTriggerObj: any;
  preferredCurrency: string;
  preferredCurrencySignal = signal<string>(CommonVariable.preferredCurrency);
  currencySymbol: string = "£";
  translatedToastMsg: any;
  languageCode: string = CommonVariable.preferredLanguage;
  selectedLanguageSignal = signal<any>([]);
  languageCodeSignal = signal<string>(CommonVariable.preferredLanguage);
  CurrencyDetailsSignal = signal<any>([]);
  flashSaleBannerExpired: boolean = false;
  private appPaymentService = inject(AppPaymentService)
  userId: string;
  @ViewChild(IonContent, { static: false }) content!: IonContent;
  constructor(
    private gameCelebrationService : GameCelebrationService
  ) {
    this.actRoute.queryParams.pipe(
      filter((params) => !!(params?.payment || params?.hofferid)),
      takeUntil(this.destroy$)
    ).subscribe((params) => {
      this.appPaymentService.initiatePayment(params);
    });
    // credit refresh
    this.creditRefreshStatusSubscription = this.gameBalanceService?.isBreakDownCreditRefreshStatus$?.subscribe(
      (data: Data) => {
        // Defensive handling: ensure data is valid before accessing properties
        const isCreditValue = data && typeof data === 'object' ? data?.status : false;
        this.isCreditRefresh.set(isCreditValue ?? false);
      },
      (error) => {
        this.authService?.errorHandlerLogs("Error in creditRefreshStatusSubscription:", error);
        this.isCreditRefresh.set(false);
      }
    );

    // jackpot trigger count
    this.jackpotActivatedCountSubscription = this.storeService?.jackpotActivatedCount$?.subscribe((count) => {
      this.jackpotTriggerActiveCount.set(count);
    });
    // Set default auto slide value
    this.autoSlide = true;
    this.isNotExpiredCard = true; // Set default value true of expire date
    this.feedBackTypeFormViewed = false; // Set default value false of feedBackTypeFormViewed
    this.speed = 500;
    this.preferredCurrency = this.userManagementService.selectedCurrency ?? CommonVariable.preferredCurrency;
    this.currencySymbol = CommonVariable.defaultCurrencySymbol;
    this.timer = 5000;

    // Added this to check if home page loaded or not to open top up popup
    this.homeDataService.initializeHomePage();

    this.languageSubscription = this.authService?.selectedlanguage$?.subscribe({
      next: (l) => {
        const lang = l ?? CommonVariable.preferredLanguage;
        this.selectedLanguageSignal.set(lang);
        this.selectedLanguage = lang;
        this.languageCodeSignal.set(lang);
        this.translate.use(lang);
        void this.storeNotificationService.resolveInlineContentForLanguage(this, lang);
      },
      error: (err) => {
        return err;
      },
    });
    this.authService?.userDetails$?.pipe(
      takeUntil(this.destroy$),
      switchMap((user: Data) => {
        const languageCode = user?.language_code || CommonVariable?.preferredLanguage;
        const preferredCurrency = user?.preferred_currency || this.userManagementService?.selectedCurrency;

        this.languageCodeSignal.set(languageCode);
        this.translate.use(languageCode);

        this.preferredCurrencySignal.set(preferredCurrency);
        this.preferredCurrency = preferredCurrency;

        return this.authService?.getCurrencyList$.pipe(take(1));
      })
    ).subscribe({
      next: (data: Data) => {
        const currencyDetails = data?.details?.find(
          (x: Data) => x?.currency_code === this.preferredCurrencySignal()
        );
        this.CurrencyDetailsSignal.set(currencyDetails);
        this.currencySymbol =
          this.CurrencyDetailsSignal()?.currency_symbol ??
          CommonVariable.defaultCurrencySymbol;
        // Clean up previous slider subscription before creating new one
        this.storeSliderSubscription?.unsubscribe();
        this.swiperManager.updateStoreSlider(this);
      },
      error: (err) => {
        this.authService.errorHandlerLogs('Error fetching user/currency details:', err);
      },
    });

    this.authService?.getConstantsMsg$?.subscribe((msg: Data) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
    this.jackpotTriggerFacade.initPreAuthListener(this);

    this.jackpotTriggerDataService?.getJackpotTriggers();
    this.notificationManagerService.narratorTipTrackerForChangeDetection$.subscribe((data) => {
      if (data?.page === "store") {
        this.changeDetectorRef.markForCheck();
      }
    });
    // This method has been used to update repeat seconds
    this.authService.postRequestRepeatSecUpdate().subscribe();
    // This method has been used to open the jackpot trigger based on the query params
    this.actRoute.queryParams.subscribe((params) => {
      if (params?.ref === "auto-refresh") {
        this.requestBodyService.isPromotionOfferSignal.set(true);
        this.storeTopUp();
      }
      if (params?.ref === "euromillions-trigger-free") {
        this.accountService.syndicatePromotion$.next(true);
        this.requestBodyService.isPromotionOfferSignal.set(true);
        localStorage.setItem("syndicatePromotion", "true");
        this.jackpotTriggerFacade.openJackpotTrigger(this, params?.ref);
      }
    });
  }

  ionViewDidEnter() {
    this.actRoute.fragment.pipe(takeUntil(this.destroy$)).subscribe(async (fragment) => {
      if (!fragment) return;
      const decoded = decodeURIComponent(fragment);
      const id = decoded || fragment;
      await new Promise((r) => requestAnimationFrame(() => r(null)));

      const el = document.getElementById(id);
      if (!el) return;
      const scrollEl = await this.content.getScrollElement();
      const top = el.getBoundingClientRect().top + scrollEl.scrollTop - 24;
      this.content.scrollToPoint(0, top, 300);
    });
  }

  goToSyndicate() {
    this.route.navigateByUrl("mainTabs/tabs/syndicate");
  }
  // This method has been used to track Celebration Animation
  ionViewWillEnter() {
    // Mark component as active when entering the view
    this.isComponentActive = true;
    this.fetchData();

    this.paymentService?.preAuthActivateTriggerResponse$
      ?.pipe(
        filter((data) => !!data),
        takeUntil(this.cleanup$)
      )
      ?.subscribe((data) => {
        const isSuccess = data?.status === "success";
        if (isSuccess) {
          this.jackpotTriggerService.setXpAnimationStop(isSuccess);
        }
        if(data?.isBackFromPreAuth){
           this.isJptActived.set(false);
        }
        this.jackpotTriggerService.setTriggerActivationStatus(isSuccess);
        this.triggerActivationStatus.set(isSuccess);
      });
    this.authService.commonUserCheck(() => {
      this.startJourney();
      this.celebrationAnimationService.trackCelebrations();
    });
    this.narratorShow();
  }
  public narratorData: Data;
  public narratorShow(): void {
    this.narratorService
      ?.getNarratorTipsHome()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response: Data[]) => {
          this.narratorData = [] as Data;
          if (Array.isArray(response) && response.length > 0) {
            const current = this.narratorService?.getCurrentPageURL();
            const pageName = current?.includes("?") ? current.split("?")[0] : current;
            for (const tip of response) {
              if (tip?.setting?.page_name === pageName && tip?.setting?.seen === false) {
                localStorage.setItem("narratorID", tip?.id);
                this.narratorData = tip;
                break;
              }
            }
          }
          if (
            this.narratorData?.setting?.seen === false &&
            (() => {
              const current = this.narratorService?.getCurrentPageURL();
              const pageName = current?.includes("?") ? current.split("?")[0] : current;
              return this.narratorData?.setting?.page_name === pageName;
            })()
          ) {
            this.notificationManagerService.addNotification(
              { ...this.narratorData, type: "narrator_tip" }
            );
          }
        },
        (error) => { this.authService.errorHandlerLogs("Error fetching narrator tips:", error);}
      );
  }
  startJourney() {
    const timestamp = new Date().getTime();
    localStorage.setItem("journeyId", timestamp.toString());
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("StorePage")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    this.flashSaleBannerExpired = false;
    this.initializePreferredCurrency();
    // this.initializeSliderManagerSubscription();
    this.initializeNotifications();
    this.initializeRouteChangeListener();
    this.initializeJackpotPromoSection();
    this.initializeOnlineStatusSubscription();
    this.initializeUserDetailsSubscription();

    this.finalizePageInitialization();

    this.sloganSubscription = this.storeService.slogans$.subscribe({
      next: (data: Data) => {
        this.slogans = data?.slogans || [];
      },
      error: (err) => {
        this.slogans = [];
        this.authService.errorHandlerLogs('Error while retrieving slogans:', err);
      }
    });
  }

  private initializePreferredCurrency(): void {
    this.storeService?.getUserPreferredCurrency$?.pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      if (res) {
        this.preferredCurrency = res;
      }
    });
    this.storeService?.flashSaleBannerExpired$?.pipe(takeUntil(this.unsubscribe$)).subscribe((res) => {
      if (res) {
        this.flashSaleBannerExpired = res;
        const currentData = this.storePageDataOne$?.getValue();
        if (currentData?.store_banners?.slides) {
          const updatedSlides = currentData?.store_banners?.slides.filter(
            (slide) => slide?.slide_info?.style !== this.flashSaleStyleString
          );
          const updatedData = {
            ...currentData,
            store_banners: {
              ...currentData?.store_banners,
              slides: updatedSlides,
            },
          };
          this.storePageDataOne$.next(updatedData);
        }
      }
    });

    // To open topup or jackpot triggers based on slidermanager data
    this.sliderManagerSubscription = this.sliderManagerService?.currentSlideData?.subscribe({
      next: (data: string) => {
        this.handleSliderManagerActions(data);
      },
      error: (err) => {
        this.authService.errorHandlerLogs("Slider manager error:", err);
      },
    });
  }

  private handleSliderManagerActions(data: string): void {
    if (data?.includes("credit") || data?.includes("auto-refresh")) {
      this.storeTopUp();
    }
    if (data?.includes("trigger")) {
      this.jackpotTriggerFacade.openJackpotTrigger(this, data);
    }
    this.loadingService.dismiss();
    this.sliderManagerService.clearLastRouteSubscription();
  }

  private initializeNotifications(): void {
    this.AuthPartialRegService.userInlineNotification()
      ?.pipe(takeUntil(this.unsubscribe$))
      .subscribe((notifications) => {
        if (notifications && notifications?.length > 0) {
          notifications.forEach((notification) => {
            if (notification?.action?.type === "Credit") {
              this.storeNotificationService.processNotification(this, notification);
            }
          });
        }
      });
  }

  private initializeRouteChangeListener(): void {
    this.route.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.unsubscribe$)
      )
      .subscribe((event: NavigationEnd) => {
        if (!event.url.includes("store")) {
          localStorage.removeItem("journeyId");
        }
      });
  }

  private initializeJackpotPromoSection(): void {
    this.storeService?.showJackpotPromoSection$?.pipe(takeUntil(this.unsubscribe$)).subscribe((value) => {
      this.showDivSlider = value;
    });
  }

  private initializeOnlineStatusSubscription(): void {
    this.catchService.isOnline$
      .pipe(
        switchMap((isOnline: any) => this.handleOnlineStatus(isOnline)),
        this.catchService.retryWhen,
        this.catchService.catchOfflineError,
        // Add defensive catchError to handle any errors that escape from switchMap
        catchError((error) => {
          this.authService.errorHandlerLogs("Error in online status subscription:", error);
          // Return empty array to prevent stream type violation
          return of([]);
        }),
        map((data: any) => {
          // Defensive check: ensure data is an array before returning
          return Array.isArray(data) ? data : [];
        }),
        takeUntil(this.unsubscribe$),
        shareReplay(1)
      )
      .subscribe({
        next: (data) => {
          // Ensure jackpots is always an array
          this.jackpots = Array.isArray(data) ? data : [];
        },
        error: (err) => {
          this.authService.errorHandlerLogs("Error fetching jackpots:", err);
          this.jackpots = [];
        },
      });
  }

  private handleOnlineStatus(isOnline: boolean): Observable<any> {
    if (isOnline) {
      const collectionRef = collection(this.firestore, `/jackpot`);
      // Wrap collectionSnapshots with error handling to prevent stream type violations
      // on permission-denied errors
      return collectionSnapshots(collectionRef).pipe(
        map((snapshots) => {
          // Defensive check: ensure snapshots is an array before processing
          if (!Array.isArray(snapshots)) {
            return [];
          }
          return snapshots;
        }),
        catchError((error) => {
          this.authService.errorHandlerLogs('Error fetching jackpot collection:', error);
          // Return empty array instead of throwing to maintain Observable type consistency
          return of([]);
        })
      );
    } else {
      return of([]); // Return empty array if offline to maintain consistent observable behavior
    }
  }

  private initializeUserDetailsSubscription(): void {
    this.authService.userDetails$?.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.jackpotTriggerService?.getTranslatedData(this.languageCodeSignal())?.subscribe({
        next: (data) => {
          // Add null/undefined check to prevent TypeError when data is not available
          if (data) {
            this.storeTranslatedData = data?.["store"];
            this.protect = this.storeTranslatedData?.jackpot_trigger_message;
          }
        },
        error: (err) => {
          this.authService.errorHandlerLogs("Error fetching translated data:", err);
        },
      });
    });
  }

  private finalizePageInitialization(): void {
    setTimeout(() => {
      this.loadings = false;
      this.changeDetectorRef.detectChanges();
      this.isToolShow = true;
    }, 10000);

    this.getAnimation();
    this.initUpdateAnimation();
  }

  getAnimation(): void {
    this.animationService
      .getAnimationFB(this.userId)
      ?.pipe(
        map((response: Data | undefined) => response?.store ?? []),
        takeUntil(this.animationDestroy$),
        catchError((error) => {
          this.authService.errorHandlerLogs("Animation fetch error:", error);
          return of([]);
        })
      )
      ?.subscribe((animations: Data[]) => {
        animations?.forEach((item) => {
          const path = `../../../assets/${item?.lottie_animation_URL ?? ""}`;
          switch (item?.location_id) {
            case "get_credit_cta":
              this.creditCTAStatus = item?.status;
              this.creditCTADuration = item?.duration;
              this.creditCTAOptions = { path };
              break;
            case "first_product_card":
              this.firstProductStatus = item?.status;
              this.firstProductDuration = item?.duration;
              this.firstProductOptions = { path };
              break;
          }
        });
      });
  }

  initUpdateAnimation() {
    this.updateAnimationSubject
      .pipe(
        concatMap(({ location_id, delayTime }) =>
          timer(delayTime * 1000).pipe(switchMap(() => this.sendUpdateStatusFB(location_id)))
        )
      )
      .subscribe();
  }

  // Dismiss the animation when user clicks on it.
  updateAnimationStatus(location_id: string, delayTime: number) {
    if (location_id && delayTime > 0 && delayTime != null) {
      this.updateAnimationSubject.next({ location_id, delayTime });
    }
  }

  onClick(location_id: string) {
    this.sendUpdateStatusFB(location_id)?.subscribe();
  }

  sendUpdateStatusFB(location_id: string) {
    if (!location_id) return of(null);

    if (this.creditCTAStatus || this.firstProductStatus) {
      return this.authService.getV2CloudFunction("updatemicroanimationv2", {
        userId: this.userId,
        locationIds: location_id,
        status: false,
      });
    } else {
      return of(null);
    }
  }

  getJackpotOrder(jackpotOrder: Data, cc: Data) {
    this.countryCode = cc?.replace("+", "");
    try {
      let topSection = [];
      let bottomSection = [];

      if (jackpotOrder?.hasOwnProperty(this.countryCodeSignal()) === true) {
        topSection = jackpotOrder[this.countryCodeSignal()]?.top ?? [];
        bottomSection = jackpotOrder[this.countryCodeSignal()]?.bottom ?? [];
      } else {
        topSection = jackpotOrder?.default?.top ?? [];
        bottomSection = jackpotOrder?.default?.bottom ?? [];
      }

      this.sortedArrayField = [...topSection, ...bottomSection];
      return this.sortedArrayField;
    } catch (err) {
      return [];
    }
  }


  ngOnDestroy() {
    // Mark component as inactive to stop all interval operations
    this.isComponentActive = false;
    this.storeNotificationService.clearExpiryTimer();

    // Clear swiper-related intervals to prevent memory leaks and recursion issues
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }

    // Clear swiper instance references
    this.swiperInstance = null;
    this.slides = null;

    if (this.cleanup$) {
      this.cleanup$.next();
      this.cleanup$.complete();
    }
    this.sliderManagerSubscription?.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.creditRefreshStatusSubscription.unsubscribe();
    this.jackpotActivatedCountSubscription.unsubscribe();
    this.sliderAliasSub?.unsubscribe();
    // unsubscribe the sample method
    if (this.sampleSubscription) {
      this.sampleSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
    if (this.animationDestroy$) {
      this.animationDestroy$.next();
      this.animationDestroy$.complete();
    }
    this.xpsDetailSubscription?.unsubscribe();
    this.languageSubscription?.unsubscribe();
    this.sloganSubscription?.unsubscribe();
  }

  ionViewWillLeave(): void {
    // Mark component as inactive when leaving the view
    this.isComponentActive = false;

    // Clear swiper intervals when leaving the view
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }

    // Clear swiper instance references
    this.swiperInstance = null;
    this.slides = null;

    this.userInboxSubscription?.unsubscribe();
  }

  isPushNotification(): boolean {
    return this.storeNotificationService.isPushNotification(this);
  }

  isAddHomeScreen(): boolean {
    return this.storeNotificationService.isAddHomeScreen(this);
  }

  onInlineNotification(notificationDetails: Data): void {
    this.storeNotificationService.handleInlineNotification(this, notificationDetails);
  }

  openProduct(productDetails) {
    if (!productDetails?.real_name) return;
    
    const queryParams = this.actRoute.snapshot.queryParams || {};
    const url = `/store/products/${productDetails.real_name}`;
   const isDiscount = productDetails?.discount_available ?? false;
    // Store as "true"/"false" so product.page can parse with === "true" (boolean setItem coerces, but keep explicit).
    localStorage.setItem("isDiscount", isDiscount ? "true" : "false");
    this.storeService?.iSdiscountAvailable.set(isDiscount);
    this.route.navigate([url]);
    this.storeService?.updatePreviousPageFromServer(url);
  }

  public pageScroller(pageTop: IonContent) {
    //scroll to page top
    if (!this.pageTop && pageTop) {
      this.pageTop = pageTop;
    } else if (!this.pageTop && !pageTop) {
      return;
    } else {
      this.pageTop?.scrollToTop();
    }
  }

  openOffer(slide: Data) {
    this.commonService.setSlideData(slide);

    // This has been used to call hotJarEvent
    if (slide?.slide_info?.style === "bundle") this.hotJarEvent();
    if (slide?.show_slide_up) {
      const showRemainderComponent = this.bottomSheet.open(OfferOfDayDetailComponent, {
        panelClass: "store-slider-dialog",
        data: { slideDetails: slide },
      });
      showRemainderComponent?.afterDismissed()?.subscribe({
        next: (description) => {
          if (description) {
            if (slide?.slide_info?.style === this.flashSaleStyleString) {
              const buttonLink = slide?.slide_up?.button_link;
              if (!buttonLink) return;
              if (buttonLink.includes("products")) {
                this.route.navigateByUrl(buttonLink);
              } else {
                this.route.navigateByUrl("mainTabs/tabs/store");
              }
            } else {
              slide["description"] = description;
              slide["page"] = "offerDay";
              this.makePayment(slide);
            }
          }
        },
        error: (err) => {
          return err;
        },
      });
    } else {
      // get DV String payload and call makePayment
      this.authService.currencyNodeDvData = slide?.slide_info;
      this.authService
        // passing the  languageCodeSignal here
        .getDVFromString(slide?.slide_up?.description)
        .then((dvString: string) => {
          if (dvString) {
            const paymentDescription = dvString
              ?.split("<li>")
              .slice(1)
              .map((x) => {
                const finalString = this.formatNumbersInString(x);
                return finalString?.split("</li>")[0];
              });
            if (paymentDescription) {
              slide["description"] = paymentDescription;
              slide["page"] = "offerOfDay";
              this.makePayment(slide);
            }
          } else {
            return "";
          }
        })
        .catch((err) => {
          return err;
        });
    }
  }

  // new flow for bundle products purchase in store slider
  async makePayment(slide: Data): Promise<void | Data> {
    this.storeService.userBackout$.next(false);
    try {
      this.setLotteryDetails(slide);
      const openPaymentModal = await this.modalController.create({
        component: StorePaymentComponent,
        componentProps: {
          data: this.formPaymentData(slide),
        },
        cssClass: "modal-fullScreen",
      });

      openPaymentModal
        .onDidDismiss()
        .then(async (res) => {
          this.slides?.slideTo(0);

          if (res?.data?.p_type === "10") {
            this.sqlAPICallResponse = res?.data?.syndicateId;
            if (!this.sqlAPICallResponse) {
              this.voucherService.setSyndicatePending();
              this.matDialog.open(RegProfileDialogComponentComponent, {
                panelClass: "ongoingWarning-size",
                backdropClass: "ongoingWarning-back-drop-color",
                disableClose: true,
              });
              return;
            }
          }

          if (res?.data?.syndicateId) {
            this.paymentService
              .getSyndicateInfoWithProducts(res?.data?.syndicateId)
              .pipe(
                map((detail: Data) => {
                  // Check if detail is a valid array with required minimum elements
                  if (!Array.isArray(detail) || !hasArrayMinLength(detail, 2)) {
                    this.authService.errorHandlerLogs('getSyndicateInfoWithProducts returned invalid array');
                    return null;
                  }

                  // Safely check detail[0] exists and has a data() method
                  const detailZero = safeArrayAccess(detail, 0, null);
                  if (!detailZero || typeof detailZero?.data !== 'function') {
                    this.authService.errorHandlerLogs('detail[0] is missing or does not have data() method');
                    return null;
                  }

                  try {
                    const syndicateInfo = detailZero.data();
                    if (!syndicateInfo || typeof syndicateInfo !== 'object') {
                      this.authService.errorHandlerLogs('syndicateInfo is invalid after calling data()');
                      return null;
                    }

                    // Check if this is a placeholder (offline/error state)
                    if (syndicateInfo.isPlaceholder || syndicateInfo.isOfflinePlaceholder) {
                      this.authService.errorHandlerLogs('Received placeholder syndicate info, skipping ticket display');
                      return null;
                    }

                    syndicateInfo.product = [];

                    // Safely access detail[1] and its docs property
                    const detailOne = safeArrayAccess(detail, 1, null);
                    const productDocs = detailOne?.docs ?? [];

                    // Filter out null/undefined docs before processing
                    if (Array.isArray(productDocs)) {
                      productDocs.forEach(doc => {
                        if (doc && typeof doc?.data === 'function') {
                          try {
                            const productData = doc.data();
                            if (productData && typeof productData === 'object') {
                              syndicateInfo?.product?.push(productData);
                            }
                          } catch (err) {
                        this.authService.errorHandlerLogs('Error extracting product data:', err);
                          }
                        }
                      });
                    }

                    syndicateInfo.cardType = "Managed";
                    return syndicateInfo;
                  } catch (err) {
                    console.error('Error in data extraction:', err);
                    return null;
                  }
                }),
                catchError((err) => {
                  this.authService.errorHandlerLogs('Error processing syndicate info:', err);
                  return of(null);
                })
              )
              .subscribe({
                next: (syndicateInfo) => {
                  if (syndicateInfo && typeof syndicateInfo === 'object') {
                    this.showTicket(syndicateInfo);
                  } else {
                    this.authService.errorHandlerLogs('No valid syndicate info available to show ticket');
                  }
                },
                error: (err) => {
                  this.authService.errorHandlerLogs('Error in syndicate subscription:', err);
                }
              });
          }
        })
        .catch((err) => {
          console.error('Error in modal dismiss:', err);
          return err;
        });

      await openPaymentModal.present();
    } catch (e) {
      console.error('Error in makePayment:', e);
      return e;
    }
  }

  setLotteryDetails(offer: Data): void {
    try {
      const lotteryDetails = {
        page: offer?.page,
        jackpot_value: offer?.slide_info?.jackpot_value,
      };
      sessionStorage.setItem("recentLotteryDetails", JSON.stringify(lotteryDetails));
    } catch (error) {
      return error;
    }
  }

  private async showTicket(syndicateInfo) {
    const syndicateTickets = await this.modalController.create({
      component: SyndicateTicketsComponent,
      componentProps: { syndicate: syndicateInfo },
      cssClass: "modal-fullScreen",
    });
    return await syndicateTickets.present();
  }

  formPaymentData(offer: Data) {
    return {
      prize: offer?.slide_info?.product_price ?? 0,
      preferred_currency: {
        prize: offer?.slide_info?.product_price ?? 0,
        currency: this.preferredCurrency,
      },
      checkout: true,
      draw: "",
      game: offer?.slider?.product_title ?? "",
      line: 1,
      offers: {
        offerid: offer?.slide_info?.offer_id ?? "",
        description: offer?.description ?? "",
        price: offer?.slide_info?.product_price ?? 0,
      },
      real_name: offer?.slider?.product_title ?? "",
      isCreatingPS: false,
      page: "offerOfDay",
      type: offer?.slide_info?.billing_type ?? "",
      discount_available:offer?.discount_available ?? false,
    };
  }

  formPaymentDataForTopUp(offer: Data) {
    const language = this.selectedLanguage || "en";

    // Prefer int_price in preferredCurrency, fallback to offer.price
    const prize = offer?.int_price?.[this.preferredCurrency] ?? offer?.price ?? 0;

    // Determine real_name based on language keys with fallback
    const realName = offer?._checkout_details?.[language] ?? offer?.checkout_details ?? "";

    return {
      prize,
      offers: offer,
      checkout: true,
      draw: "",
      game: offer?.checkout_details ?? "",
      line: "",
      offer_id: offer?.award_id?.[this.preferredCurrency] ?? "",
      real_name: realName,
      isTopUp: true,
      page: "topUp",
    };
  }

  getUrl(url: string) {
    return "url('" + url + "')";
  }

  storeTopUp() {
    const storeTopUp = this.bottomSheet.open(StoreTopUpComponent, {
      panelClass: ["store-top-up-bottomsheet", "bottom-sheet-transparent"],
    });
    storeTopUp?.afterDismissed()?.subscribe(
      (response) => {
        if (response) {
          this.sliderManagerService.currentSlideData.next("");
          this.routeToStorePayment(response);
        }
      },
      (err) => {
        return err;
      }
    );
  }
  // This Method is used to route to Add new payment card
  async routeToStorePayment(topUpData) {
    const queryParams = this.actRoute.snapshot.queryParams || {};
    if (topUpData.content.sub_title === "Auto Refresh") {
      this.route.navigate([`/account/payment-add`], { queryParams });
    } else {
      const storePayment = await this.modalController.create({
        component: StorePaymentComponent,
        cssClass: "modal-fullScreen",
        componentProps: {
          data: this.formPaymentDataForTopUp(topUpData),
        },
      });

      return await storePayment.present();
    }
  }

  openMessage(message: Data) {
    if (!message) return;
    if (this.authService.templateNameArray.includes(message?.template_name)) {
      this.AuthPartialRegService.openAutoShowInbox(message);
    } else {
      const panelClass = this.orientationService.isFullscreen()
        ? "inbox-bottom-sheet-fullscreen"
        : message?.template_type === "plunko_christmas" || message?.template_type === "valentine_plunko_campaign"
          ? "bottom-sheet-fullscreen"
          : "inbox-bottom-sheet";
      this.bottomSheet.open(InboxMessageComponent, {
        panelClass: panelClass,
        data: message,
      });
    }
  }

  daysToWeek(days) {
    if (Number(days) > 14) {
      let week = Number(days) / 7;
      return week;
    }
  }

  daysToHours(days, hours) {
    if (Number(days) === 1) {
      let hour = Number(days) * 24 + Number(hours);
      return hour;
    } else {
      return hours;
    }
  }

  hourToMinutes(hours, minutes) {
    if (Number(hours) === 1) {
      let min = Number(hours) * 60 + Number(minutes);
      return min;
    } else {
      return minutes;
    }
  }

  hideCoachMark() {
    if (this.isTooltipVisible) {
      this.authService.hideCoachMarkPopup();
    }
  }

  showDiv(val: boolean) {
    this.showDivSlider = !val;
  }
  showTriggerDetails(triggerData: Data): void {
    this.jackpotTriggerFacade.openTriggerDetails(this, triggerData);
  }

  onAnimationComplete(): void {
    this.jackpotTriggerFacade.onAnimationComplete(this);
  }
  getJackpotValue(amount: string): number {
    // Defensive check: ensure amount is a valid string
    if (typeof amount !== "string" || amount === null || amount === undefined) {
      return 0; // Return a default numeric value or handle as appropriate
    }
    
    try {
      if (amount.includes("K")) {
        const numValue = parseFloat(amount.replace("K", ""));
        return isNaN(numValue) ? 0 : numValue * 1000;
      } else if (amount.includes("M")) {
        const numValue = parseFloat(amount.replace("M", ""));
        return isNaN(numValue) ? 0 : numValue * 1000000;
      } else if (amount.includes("B")) {
        const numValue = parseFloat(amount.replace("B", ""));
        return isNaN(numValue) ? 0 : numValue * 1000000000;
      } else {
        // Try to parse as plain number
        const numValue = parseFloat(amount);
        return isNaN(numValue) ? 0 : numValue;
      }
    } catch (error) {
      console.error('Error parsing jackpot value:', error);
      return 0;
    }
  }
  prev() {
    return this.swiperManager.prev(this);
  }
  next() {
    return this.swiperManager.next(this);
  }
  slidePrev() {
    return this.swiperManager.slidePrev(this);
  }
  slideNext() {
    return this.swiperManager.slideNext(this);
  }
  onStoreCardSwiper(swiper): void {
    this.swiperManager.setSwiperInstance(this, swiper);
  }

  onJackpotSwiper(swiper): void {
    this.swiperManager.setSwiperInstanceJackpot(this, swiper);
  }

  formatNumbersInString(originalString: string): string {
    return formatDecimalNumbersInString(originalString);
  }

  hotJarEvent() {
    this.GTMSagmentService.HotJarEvent("store_bundle");
  }

  formatValue(value) {
    // Splitting the value into an array using the decimal point as the delimiter
    let formattedValue = value?.split(".");
    // Extracting numbers and strings from the second part of the split value
    let inputString = formattedValue?.[1] || ""; // Handling null or undefined case
    // Extracting the numeric part using regular expression
    const numericMatch = inputString?.match(/^\d+/);
    const numericPart = numericMatch ? numericMatch?.[0] : "";

    // Extracting the string part using regular expression
    const stringMatch = inputString?.match(/[A-Za-z]+$/);
    const stringPart = stringMatch ? stringMatch?.[0] : "";

    let finalValue =
      formattedValue?.[0] + (numericPart !== "0" ? (formattedValue?.[1] ? "." + numericPart : "") : "") + stringPart;
    return finalValue;
  }
  // This function is call when user click first retool card
  RetoolCardCta(url: string) {
    this.route.navigateByUrl(url);
  }
  dismissFeedback(): void {
    this.storeNotificationService.feedBackDismiss(this);
  }

  fetchData() {
    this.storeService.storeData$
      ?.pipe(
        filter((data: Data | null | undefined) => !!data), // Ensure data is not null/undefined
        map((data: Data) => {
          // Defensive check for jackpot arrays
          const topJackpots = Array.isArray(data?.top_jackpots) ? data.top_jackpots : [];
          const bottomJackpots = Array.isArray(data?.bottom_jackpots) ? data.bottom_jackpots : [];
          return {
            data,
            storePageData: [...topJackpots, ...bottomJackpots],
          };
        }),
        tap(({ data }) => {
          // Remove bold tags from line_1 on every inline notification (selector may use index > 0)
          if (Array.isArray(data?.inline_notifications)) {
            for (const notification of data.inline_notifications) {
              const line1 = notification?.content?.line_1 ?? "";
              if (typeof line1 === "string" && line1 && notification?.content) {
                notification.content.line_1 = this.removeEndBoldTag(line1);
              }
            }
          }
        }),
        catchError((error) => {
          this.authService.errorHandlerLogs("Error retrieving data:", error);
          return of({ data: null, storePageData: [] });
        })
      )
      .subscribe(({ data, storePageData }) => {
        if (this.isComponentActive && data) {
          this.storePageData = Array.isArray(storePageData) ? storePageData : [];
          // Add the isOneOff property to each slide with safe iteration
          if (Array.isArray(data?.store_banners?.slides)) {
            data.store_banners.slides.forEach((slide: Data) => {
              if (slide && typeof slide === 'object') {
                const description = slide.slide_up?.description || [];
                slide.isOneOff = Array.isArray(description) ? description.includes('one-off') : false;
              }
            });
          }
          this.storePageDataOne$.next(data);
          this.storeNotificationService.validateNotifications(this, data);
        }
      });
  }

  removeEndBoldTag(str: string): string {
    return str.replace(/<\/?b>/gi, "");
  }

  /**
   * Checks if the provided expiry date for the jackpot has passed or calculates the time remaining.
   *
   * @param {number} expdata - The expiry date as a UNIX timestamp (in seconds).
   * @returns {string} - Returns "expired" if the date has passed, otherwise returns the formatted time remaining.
   */
  checkForJackpotDrawDate(expdata: number): string | boolean {
    if (!expdata || isNaN(expdata)) return false; // Ensure expdata is valid
    // Convert the UNIX timestamp (seconds) to milliseconds.
    const expiryDate = expdata * 1000;
    // Get the current time in milliseconds.
    const now = Date.now();
    // Calculate the time difference between expiry date and current time.
    const timeDifference = expiryDate - now;

    // If the time has expired, return "expired", otherwise return formatted remaining time.
    if (timeDifference <= 0) {
      this.isNotExpiredCard = false;
      return "expired";
    } else {
      return this.formatTime(timeDifference);
    }
  }

  /**
   * Formats the time remaining in days, hours, minutes, and seconds.
   *
   * @param {number} ms - The time difference in milliseconds.
   * @returns {string} - A formatted string representing the time remaining.
   */
  private formatTime(ms: number): string {
    // Calculate the number of seconds, minutes, hours, and days.
    const seconds = Math.floor((ms / 1000) % 60);
    const minutes = Math.floor((ms / (1000 * 60)) % 60);
    const hours = Math.floor((ms / (1000 * 60 * 60)) % 24);
    const days = Math.floor(ms / (1000 * 60 * 60 * 24));

    // If the remaining time includes days, format the time as "Xd Yhrs Zm".
    if (days > 0) {
      return `${days}d ${hours}hrs ${minutes}m`;
    } else {
      let formattedTime = "";
      // Format the hours, minutes, and seconds only if applicable.
      if (hours > 0) {
        formattedTime += `${hours}hrs `;
      }
      if (minutes > 0) {
        formattedTime += `${minutes}m `;
      }
      if (seconds > 0) {
        formattedTime += `${seconds}s`;
      }
      // Trim and return the formatted string.
      return formattedTime.trim();
    }
  }
  // OnSlideChanges
  onSlideChange() {
    this.swiperManager.onSlideChange(this);
  }
  getIconUrl(iconUrl: string | undefined): string {
    return this.authService.getIconUrl(iconUrl);
  }

  // This method has been used to open payment page
  activateJackpotTrigger(data: Data): void {
    this.jackpotTriggerFacade.openPaymentPage(this, data);
  }

  getSafeBackground(bg: string | null): SafeStyle {
    const cleaned = (bg || "")?.replace(/\u00A0/g, " "); // Replace non-breaking spaces
    return this.sanitizer.bypassSecurityTrustStyle(cleaned);
  }

  handleCountdownFinish(): void {
    this.notificationsService.updateClaiminlineVoucherDismiss(this.inlineNotificationDetails?.notification_id?.path);
  }

  getLotteryLines(lotteryName: string): string | null {
    if (!lotteryName || !this.slogans?.length) {
      return null;
    }

    const slogan = this.slogans.find(
      (s) => s?.config?.lottery === lotteryName
    );

    return slogan?.config?.texts?.[this.selectedLanguage] ?? null;
  }
}
